<template>
  <standard-dialog
    v-model="model"
    :title="formTitle"
    :subtitle="editedItem?.id ? 'ID: ' + editedItem.id : ''"
    icon="mdi-truck-fast"
    @save="save"
    :max-width="800"
  >
    <v-container style="padding-bottom: 10px !important">
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <text-field
            v-model="editedItem.name"
            :rules="[rules.required]"
            :label="$t('title')"
            required
          ></text-field>
        </v-col>
        <v-col v-if="companies.length" cols="12" md="6" lg="4">
          <autocomplete
            v-model="editedItem.parent"
            :items="[{ name: '', id: null }].concat(companies.filter((item) => item.id))"
            :label="$t('parent_company')"
            item-text="name"
            item-id="id"
            return-object
          ></autocomplete>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <autocomplete
            @change="onCountryChange"
            v-model="editedItem.country"
            :items="countries"
            :label="$t('country')"
            item-text="name"
            item-id="id"
            return-object
          ></autocomplete>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <autocomplete
            v-model="editedItem.city"
            @change="onCityChange"
            :items="cities ? cities : []"
            :label="$t('city')"
            item-text="name"
            item-id="id"
            return-object
          ></autocomplete>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.address" :label="$t('address')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.latitude" :label="$t('lati1')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.longitude" :label="$t('long1')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.phone" :label="$t('phone')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.email" :label="'* ' + $t('email')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.jib" :label="$t('jib')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.pib" :label="$t('pib')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.owner" :label="$t('owner')"></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field
            v-model="editedItem.contact_person"
            :label="$t('contact_person')"
          ></text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <text-field v-model="editedItem.contract" :label="$t('contract')"></text-field>
        </v-col>
      </v-row>
    </v-container>
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasModel from "@/mixins/hasModel";
import { deliveryCompany } from "@/models/company";
import companyService from "@/services/company";

export default {
  name: "DeliveryCompanyDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
  },
  props: {
    editedItem: {
      type: Object,
      default: () => ({ ...deliveryCompany }),
    },
    companies: {
      type: Array,
      default: () => [],
    },
    countries: {
      type: Array,
      default: () => [],
    },
    cities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    formTitle() {
      return this.editedItem?.id ? this.$t("edit_item") : this.$t("new_item");
    },
  },
  methods: {
    onCountryChange() {
      this.$emit("country-change");
    },
    onCityChange() {
      this.$emit("city-change");
    },
    async save() {
      try {
        this.editedItem.parent_id = this.editedItem.parent
          ? this.editedItem.parent.id
          : 0;

        if (this.editedItem.id) {
          // Update existing company
          await companyService.updateDeliveryCompany(this.editedItem.id, this.editedItem);
          this.showSuccessSnackbar(this.$t("delivery_company_updated"));
          this.$emit("company-updated", {
            item: this.editedItem,
          });
        } else {
          // Create new company
          const res = await companyService.createDeliveryCompany(this.editedItem);
          this.editedItem.id = res.data.id;
          this.showSuccessSnackbar(this.$t("delivery_company_created"));
          this.$emit("company-created", this.editedItem);
        }
        this.close();
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_saving_delivery_company"));
      }
    },
    close() {
      this.model = false;
      this.$emit("close");
    },
  },
};
</script>
